import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

/**
 * Animation for HeadingBox - title and description fade in
 */
export const animateHeadingBox = (wrapperRef, titleRef, descriptionRef) => {
  if (wrapperRef.current && titleRef.current && descriptionRef.current) {
    // Set initial state immediately to prevent flash
    gsap.set(titleRef.current, { opacity: 0, y: -30 });
    gsap.set(descriptionRef.current, { opacity: 0, y: 20 });
    
    const timer = setTimeout(() => {
      gsap.to(titleRef.current, {
        opacity: 1,
        y: 0,
        duration: 1,
        ease: "power3.out",
        scrollTrigger: {
          trigger: wrapperRef.current,
          start: "top 85%",
          toggleActions: "play none none none",
        },
      });
      
      gsap.to(descriptionRef.current, {
        opacity: 1,
        y: 0,
        duration: 1,
        delay: 0.3,
        ease: "power2.out",
        scrollTrigger: {
          trigger: wrapperRef.current,
          start: "top 85%",
          toggleActions: "play none none none",
        },
      });
      
      ScrollTrigger.refresh();
    }, 100);
    
    return () => clearTimeout(timer);
  }
};

